/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { CSSProperties } from 'react';

import { AlertConfig } from '@/client';

export type DestinationType = 'exabeam' | 'slack' | 'splunk';

export type AlertWizardStep = 'setup-connection' | 'set-parameters' | 'review';

export const destinationDisplayNames: Record<DestinationType, string> = {
  exabeam: 'Exabeam',
  slack: 'Slack',
  splunk: 'Splunk',
};

export const tagStyle: CSSProperties = {
  backgroundColor: '#f5f5f5',
  color: '#333',
  borderColor: '#e8e8e8',
};

export const monoTagStyle: CSSProperties = {
  ...tagStyle,
  fontFamily: 'monospace',
  fontSize: '13px',
};

export function getWebhookUrl(alert: AlertConfig): string {
  const config = alert as AlertConfig & { config?: Record<string, unknown> };
  if (!config.config) return '';
  return (
    (config.config.slackWebhook as string) ||
    (config.config.exabeamWebhook as string) ||
    (config.config.splunkWebhook as string) ||
    ''
  );
}

export function getToken(alert: AlertConfig): string {
  const config = alert as AlertConfig & { config?: Record<string, unknown> };
  if (!config.config) return '';
  return (config.config.exabeamToken as string) || (config.config.splunkToken as string) || '';
}

export function getDisableTls(alert: AlertConfig): boolean {
  const config = alert as AlertConfig & { config?: Record<string, unknown> };
  if (!config.config) return false;
  return (config.config.disableTlsVerification as boolean) || false;
}
